import Arrow from './Arrow';
import ArrowLeft from './ArrowLeft';
import BackIcon from './BackIcon';
import Check from './Check';
import CircleCheck from './CircleCheck';
import CircleError from './CircleError';
import CircleInfo from './CircleInfo';
import CircleWarning from './CircleWarning';
import Close from './Close';
import CloseHint from './CloseHint';
import ConsultationPencil from './ConsultationPencil';
import Delete from './Delete';
import Download from './Download';
import Duration from './Duration';
import Edit from './Edit';
import EuroSign from './EuroSign';
import EyeOff from './EyeOff';
import EyeOn from './EyeOn';
import Facebook from './Facebook';
import File from './File';
import Finance from './Finance';
import Fullscreen from './Fullscreen';
import FunnelBackIcon from './FunnelBackIcon';
import FunnelMobileBackButton from './FunnelMobileBackButton';
import Google from './Google';
import GreenCheck from './GreenCheck';
import Hamburger from './Hamburger';
import Info from './Info';
import Instagram from './Instagram';
import Linkedin from './Linkedin';
import Location from './Location';
import Mail from './Mail';
import Minus from './Minus';
import MymoriaLogo from './MymoriaLogo';
import MymoriaLogoDark from './MymoriaLogoDark';
import MymoriaLogoWhite from './MymoriaLogoWhite';
import Note from './Note';
import Offer from './Offer';
import OpenHint from './OpenHint';
import Other from './Other';
import Pencil from './Pencil';
import Phone from './Phone';
import Plus from './Plus';
import ProvisionPortalLogo from './ProvisionPortalLogo';
import Radio from './Radio';
import RatingStar from './RatingStar';
import Refresh from './Refresh';
import Reload from './Reload';
import SpeechBubble from './SpeechBubble';
import TrustedPerson from './TrustedPerson';
import User from './User';
import ValidateError from './ValidateError';
import ValidateSuccess from './ValidateSuccess';
import Wishes from './Wishes';
import Xing from './Xing';
import Youtube from './Youtube';
import Zoom from './Zoom';
import * as Mymoria from './mymoria';
export default {
    BackIcon: BackIcon,
    Close: Close,
    CloseHint: CloseHint,
    CircleCheck: CircleCheck,
    CircleError: CircleError,
    CircleWarning: CircleWarning,
    CircleInfo: CircleInfo,
    File: File,
    Info: Info,
    Mail: Mail,
    Pencil: Pencil,
    Phone: Phone,
    Youtube: Youtube,
    Facebook: Facebook,
    Instagram: Instagram,
    Radio: Radio,
    ValidateError: ValidateError,
    ValidateSuccess: ValidateSuccess,
    Offer: Offer,
    OpenHint: OpenHint,
    Other: Other,
    ConsultationPencil: ConsultationPencil,
    Wishes: Wishes,
    Finance: Finance,
    TrustedPerson: TrustedPerson,
    User: User,
    Linkedin: Linkedin,
    Xing: Xing,
    Arrow: Arrow,
    Note: Note,
    Edit: Edit,
    Download: Download,
    Duration: Duration,
    Delete: Delete,
    Location: Location,
    Hamburger: Hamburger,
    MymoriaLogo: MymoriaLogo,
    ProvisionPortalLogo: ProvisionPortalLogo,
    Check: Check,
    RatingStar: RatingStar,
    Google: Google,
    MymoriaLogoWhite: MymoriaLogoWhite,
    EyeOff: EyeOff,
    EyeOn: EyeOn,
    MymoriaLogoDark: MymoriaLogoDark,
    Mymoria: Mymoria,
    Plus: Plus,
    Refresh: Refresh,
    Reload: Reload,
    SpeechBubble: SpeechBubble,
    GreenCheck: GreenCheck,
    EuroSign: EuroSign,
    Zoom: Zoom,
    Minus: Minus,
    FunnelBackIcon: FunnelBackIcon,
    FunnelMobileBackButton: FunnelMobileBackButton,
    Fullscreen: Fullscreen,
    ArrowLeft: ArrowLeft,
};
//# sourceMappingURL=index.js.map